import * as React from "react";

import { Input } from "@/components/ui/input";

// Alguns navegadores antigos não mascaram texto por CSS. Neles o campo volta a
// ser `type="password"` (com `new-password`, que já impede o preenchimento
// automático de credencial salva) em vez de mostrar o token na tela.
const MASCARA_CSS =
  typeof window !== "undefined" &&
  typeof window.CSS !== "undefined" &&
  typeof window.CSS.supports === "function" &&
  window.CSS.supports("-webkit-text-security", "disc");

/** Campo de CREDENCIAL DE INTEGRAÇÃO (token, API key, webhook secret).
 *
 *  Com `type="password"` o Chrome liga o gerenciador de senhas na tela inteira:
 *  joga a senha da CONTA dentro do campo do token (o lojista salvaria a própria
 *  senha como Access Token do Mercado Pago) e despeja o usuário salvo no
 *  primeiro campo de texto da página — era assim que "Addad" aparecia na busca
 *  do menu lateral ao abrir Configurações → Integração. Aqui o campo é texto
 *  comum mascarado por CSS: sai do radar do gerenciador e continua escondendo o
 *  valor de quem olha a tela.
 *
 *  NÃO usar em senha de verdade (login, trocar senha, confirmar com senha do
 *  admin): essas continuam `type="password"` com o `autoComplete` correto, pra
 *  o navegador saber salvar e preencher. */
const InputSecret = React.forwardRef(function InputSecret({ style, ...props }, ref) {
  return (
    <Input
      ref={ref}
      type={MASCARA_CSS ? "text" : "password"}
      autoComplete={MASCARA_CSS ? "off" : "new-password"}
      autoCorrect="off"
      autoCapitalize="off"
      spellCheck={false}
      data-lpignore="true"
      data-1p-ignore=""
      data-form-type="other"
      style={MASCARA_CSS ? { WebkitTextSecurity: "disc", ...style } : style}
      {...props}
    />
  );
});

export { InputSecret };
